<template>
  <div
    class="tooltip-container"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'VasionTooltip',
  props: {
    text: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: 'top',
      validator: value => ['top', 'bottom', 'left', 'right'].includes(value),
    },
  },
  data() {
    return {
      showTimeout: null, // Timeout reference for the delay
      visible: false,
      tooltipEl: null,
    }
  },
  methods: {
    showTooltip() {
      // Add a 500ms delay before showing the tooltip
      this.showTimeout = setTimeout(() => {
        this.createTooltip()
        this.visible = true
      }, 500)
    },
    hideTooltip() {
      // Clear the timeout to prevent showing the tooltip if the mouse leaves early
      clearTimeout(this.showTimeout)
      this.showTimeout = null
      this.visible = false
      this.removeTooltip()
    },
    createTooltip() {
      if (!this.tooltipEl) {
        this.tooltipEl = document.createElement('div')
        this.tooltipEl.className = `tooltip ${this.position}`
        this.tooltipEl.textContent = this.text
        document.body.appendChild(this.tooltipEl)
      }
      this.positionTooltip()
    },
    removeTooltip() {
      if (this.tooltipEl) {
        document.body.removeChild(this.tooltipEl)
        this.tooltipEl = null
      }
    },
    positionTooltip() {
      this.$nextTick(() => {
        const rect = this.$el.getBoundingClientRect()
        const tooltip = this.tooltipEl

        if (!tooltip) return

        Object.assign(tooltip.style, {
          position: 'absolute',
          zIndex: '9999',
          whiteSpace: 'normal',
          maxWidth: '400px',
          padding: '8px',
          background: 'black',
          color: 'white',
          borderRadius: '4px',
          opacity: '0.9',
          fontSize: '14px',
        })

        const screenWidth = window.innerWidth
        const screenHeight = window.innerHeight

        let left, top

        switch (this.position) {
          case 'top':
            left = rect.left + rect.width / 2 - tooltip.offsetWidth / 2
            top = rect.top - tooltip.offsetHeight - 8
            break
          case 'bottom':
            left = rect.left + rect.width / 2 - tooltip.offsetWidth / 2
            top = rect.bottom + 8
            break
          case 'left':
            left = rect.left - tooltip.offsetWidth - 8
            top = rect.top + rect.height / 2 - tooltip.offsetHeight / 2
            break
          case 'right':
            left = rect.right + 8
            top = rect.top + rect.height / 2 - tooltip.offsetHeight / 2
            break
        }

        left = Math.max(
          8,
          Math.min(left, screenWidth - tooltip.offsetWidth - 8)
        )
        top = Math.max(
          8,
          Math.min(top, screenHeight - tooltip.offsetHeight - 8)
        )

        tooltip.style.left = `${left}px`
        tooltip.style.top = `${top}px`
      })
    },
  },
  beforeDestroy() {
    this.removeTooltip()
    clearTimeout(this.showTimeout)
  },
}
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}
</style>
